import type { FaireProductEntity } from "../../entity_types/product";

export const p_2f3v7qfzzu: FaireProductEntity = {
  token: "p_2f3v7qfzzu",
  type: "product",
  name: "Pork and Apple",
  brandToken: "b_nsfmhqefxn",
  brandName: "Saint Rocco's Treats",
  imageUrl: "https://cdn.faire.com/fastly/bba63e485b5de4d5a8e30ced95bf8ca7ebbc0715059f7e457cb4569960979333.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/61dc8f85ac9d8a68eb336d11eb1c218ca3131bf8488aea5364a4b0bbe34d09a9.jpeg",
    "https://cdn.faire.com/fastly/0dba38445d2ebaf2d87ca8268bbfbd3a9ea1f3a990c011ce523b3bef217bea94.jpeg",
    "https://cdn.faire.com/fastly/633984ab18ab87cfeea975d649f957edeadfeb127def481a5384ecff61f01022.jpeg"
  ],
  priceDollars: 58,
  description: "Are your customers searching for all-natural, easy-to-break, crumb-free training treats?\n\nOur Pork and Apple treats are hand-crafted in small batches daily in our Bucks County, PA, gourmet dog kitchen.\n\nEach Pork and Apple recipe includes premium ingredients: Human-grade Pork, Dried Apples, Potato Flour, Coconut Glycerin, and our homemade seasoning of Turmeric, Salt, and Paprika.\n\nOur human-grade recipe and commitment to freshness create an irresistible treat that is easy to break for training and rewarding dogs of all ages and sizes.\n\nImpress your pickiest eaters today with our Pork and Apple treat.\n\nPork and Apple Guaranteed Analysis & Calorie Content:\n\n• Crude Protein - 23.6%\n• Crude Fat - 15.7%\n• Crude Fiber - 1.56%\n• Moisture - 27.08%\n\nCalorie per strip = 71 kcal | 7-8 strips per 8oz package\n\nAll Saint Rocco's Treats have a 12-month shelf life when resealed after each use & kept in a room temperature, dry environment.",
  tags: [],
  msrpDollars: 116,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:59.902Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
